export default {
	"banner_activity_id": 38,
	"content": "<p style=\"text-align: center;\"><br></p><p><span>&nbsp;</span>1.发售渠道：奈雪の茶心意卡券在“奈雪点单”小程序内独立发售，适用独立的价格体系（奈雪の茶心意卡券为电子卡，非实体卡）。</p><p><span>2.兑换产品：凭借奈雪の茶心意卡券，可在中国境内（香港、台湾、澳门地区除外）各适用门店免费兑换相应卡券上载明的产品。</span></p><p><span>3.&nbsp;转赠功能：购买卡券后可直接放入购卡人礼品卡列表，或在24小时内将卡券转赠给好友，仅可转赠一次；如您送出的心意卡券未在转赠后24小时内被您的好友领取，则未领取的卡券将自动退回到您的礼品卡列表且无法再次转赠，届时您可自行使用。如购买多张卡券后需赠送给不同好友，需进入礼品卡列表，查看单个礼品卡详情时进行赠送。</span></p><p><span>4.有效期限：奈雪の茶心意卡券自购买之日起三年内有效。</span></p><p>5.适用范围：奈雪の茶心意卡券可在中国境内（香港、台湾、澳门地区除外）奈雪の茶门店内的柜台与小程序使用，受限于具体可兑换的产品及其相应的销售渠道。</p><p><span>6.下单限制：奈雪の茶心意卡券可在奈雪の茶门店出示会员码后使用，或在“奈雪点单”小程序内使用，小程序堂食与小程序外送订单均支持；不适用与第三方在线点餐平台的外送业务等渠道订单。</span></p><p><span>7.优惠并用：奈雪の茶心意卡券可以和其他优惠券同时使用。</span></p><p><span>8.扫码核销：请在点单前向服务员明示，奈雪の茶心意卡券不可兑换现金，不设找零。</span></p><p><span>9.售罄预案：如奈雪の茶心意卡券可兑换的产品临时售罄，可根据服务员的指引为您替换类似价格的产品。</span></p><p><span>10.&nbsp;留言功能：您在转赠奈雪の茶心意卡券时，您可在留言栏里为好友填写留言。好友在打开您所赠送的心意卡券的同时，也能收到并查阅您的留言。需注意的是，您在使用上述留言功能时，应遵守所适用的中国法律法规及平台协议与规范，可见《微信公众平台服务协议》、《微信公众平台运营规范》、《腾讯服务协议》以及微信公众平台运营方制定并不时修订的其他规则和规定，并承担与此相关的所有法律责任。</span></p><p><span>11.退款处理：</span><span>在购买卡券之日起15日内，如卡券未经激活、绑定或使用的，购卡人方可申请退卡。对于符合退卡条件的预付卡，发卡企业将扣取卡内资金余额的2%作为退卡手续费。如退卡人要求退还其在购买时享受过任何折扣或优惠的卡券，发卡企业或售卡企业在计算退款时将按退卡人在购买时实际支付的金额或按该卡券全额扣除上述优惠后的金额办理退款。如退卡人购买卡券可按其年度累计购卡金额享有任何折扣或优惠的，发卡企业在办理退卡后会将退卡金额从其年度累计购卡金额中扣除。</span><span>前述“符合退卡条件”的具体情况如下：</span></p><p><span>(1)退款人必须是奈雪の茶心意卡券的购买人，若转赠成功，则奈雪の茶心意卡券不接受退款；在任何情况下，获得心意卡券的受赠人不予进行退款处理。</span></p><p><span>(2)上述“成功转赠”仅包括受赠人点击领取接受所转赠的心意卡券的情况，而不包括超过转赠后的24小时内受赠人未接受而该心意卡券将自动退还并添加到赠送人礼品卡列表的情况。</span></p><p><span>12.开具发票：您在购买奈雪の茶心意卡券后可在“奈雪点单”小程序-我的-我的订单内，找到对应的礼品卡购买记录，点击“开发票”。&nbsp;</span></p><p><span>13.其他问题：如有其他疑问，请致电奈雪の茶客服热线电话4008-3099-56。</span></p><p>\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n</p><p>&nbsp;</p><style>\n@font-face{\nfont-family:\"Times New Roman\";\n}\n\n@font-face{\nfont-family:\"宋体\";\n}\n\n@font-face{\nfont-family:\"Calibri\";\n}\n\n@font-face{\nfont-family:\"Microsoft YaHei UI\";\n}\n\n@list l0:level1{\nmso-level-start-at:3;\nmso-level-number-format:decimal;\nmso-level-suffix:tab;\nmso-level-text:\"%1.\";\nmso-level-tab-stop:15.6000pt;\nmso-level-number-position:left;\nmargin-left:0.0000pt;\ntext-indent:0.0000pt;\nfont-family:'Times New Roman';}\n\n@list l1:level1{\nmso-level-start-at:10;\nmso-level-number-format:decimal;\nmso-level-suffix:tab;\nmso-level-text:\"%1.\";\nmso-level-tab-stop:15.6000pt;\nmso-level-number-position:left;\nmargin-left:0.0000pt;\ntext-indent:0.0000pt;\nfont-family:'Times New Roman';}\n\np.MsoNormal{\nmso-style-name:正文;\nmso-style-parent:\"\";\nmargin:0pt;\nmargin-bottom:.0001pt;\nmso-pagination:none;\ntext-align:justify;\ntext-justify:inter-ideograph;\nfont-family:Calibri;\nmso-fareast-font-family:宋体;\nmso-bidi-font-family:'Times New Roman';\nfont-size:10.5000pt;\nmso-font-kerning:1.0000pt;\n}\n\np.p{\nmso-style-name:\"普通\\(网站\\)\";\nmargin-top:5.0000pt;\nmargin-right:0.0000pt;\nmargin-bottom:5.0000pt;\nmargin-left:0.0000pt;\nmso-margin-top-alt:auto;\nmso-margin-bottom-alt:auto;\nmso-pagination:none;\ntext-align:left;\nfont-family:Calibri;\nmso-fareast-font-family:宋体;\nmso-bidi-font-family:'Times New Roman';\nfont-size:12.0000pt;\n}\n\nspan.msoIns{\nmso-style-type:export-only;\nmso-style-name:\"\";\ntext-decoration:underline;\ntext-underline:single;\ncolor:blue;\n}\n\nspan.msoDel{\nmso-style-type:export-only;\nmso-style-name:\"\";\ntext-decoration:line-through;\ncolor:red;\n}\n@page{mso-page-border-surround-header:no;\n\tmso-page-border-surround-footer:no;}@page Section0{\nmargin-top:72.0000pt;\nmargin-bottom:72.0000pt;\nmargin-left:90.0000pt;\nmargin-right:90.0000pt;\nsize:595.3000pt 841.9000pt;\nlayout-grid:15.6000pt;\n}\ndiv.Section0{page:Section0;}</style><style>\n@font-face{\nfont-family:\"Times New Roman\";\n}\n\n@font-face{\nfont-family:\"宋体\";\n}\n\n@font-face{\nfont-family:\"Calibri\";\n}\n\n@font-face{\nfont-family:\"Microsoft YaHei UI\";\n}\n\np.MsoNormal{\nmso-style-name:正文;\nmso-style-parent:\"\";\nmargin:0pt;\nmargin-bottom:.0001pt;\nmso-pagination:none;\ntext-align:justify;\ntext-justify:inter-ideograph;\nfont-family:Calibri;\nmso-fareast-font-family:宋体;\nmso-bidi-font-family:'Times New Roman';\nfont-size:10.5000pt;\nmso-font-kerning:1.0000pt;\n}\n\np.p{\nmso-style-name:\"普通\\(网站\\)\";\nmargin-top:5.0000pt;\nmargin-right:0.0000pt;\nmargin-bottom:5.0000pt;\nmargin-left:0.0000pt;\nmso-margin-top-alt:auto;\nmso-margin-bottom-alt:auto;\nmso-pagination:none;\ntext-align:left;\nfont-family:Calibri;\nmso-fareast-font-family:宋体;\nmso-bidi-font-family:'Times New Roman';\nfont-size:12.0000pt;\n}\n\nspan.msoIns{\nmso-style-type:export-only;\nmso-style-name:\"\";\ntext-decoration:underline;\ntext-underline:single;\ncolor:blue;\n}\n\nspan.msoDel{\nmso-style-type:export-only;\nmso-style-name:\"\";\ntext-decoration:line-through;\ncolor:red;\n}\n@page{mso-page-border-surround-header:no;\n\tmso-page-border-surround-footer:no;}@page Section0{\nmargin-top:72.0000pt;\nmargin-bottom:72.0000pt;\nmargin-left:90.0000pt;\nmargin-right:90.0000pt;\nsize:595.3000pt 841.9000pt;\nlayout-grid:15.6000pt;\n}\ndiv.Section0{page:Section0;}</style>",
	"category_list": [{
		"id": 41,
		"themesList": [{
			"activityId": 41,
			"activityName": "梦回童年六一玩趣",
			"activityCode": "474613760767721473",
			"cardShelvesCategoryId": 41,
			"imageUrls": "https://img-shop.qmimg.cn/s36192/2020/06/02/feb01bdc9e018d7a22.jpg"
		}, {
			"activityId": 42,
			"activityName": "“大宝宝”通行证",
			"activityCode": "474613956256256001",
			"cardShelvesCategoryId": 41,
			"imageUrls": "https://img-shop.qmimg.cn/s36192/2020/06/02/c58ae1b6c7af70ace3.jpg"
		}],
		"name": "送TA六一限定卡，陪TA一口回到童年",
		"activityIds": "41,42"
	}, {
		"id": 42,
		"themesList": [{
			"activityId": 40,
			"activityName": "拥抱我的小宇宙",
			"activityCode": "474613468311351298",
			"cardShelvesCategoryId": 42,
			"imageUrls": "https://img-shop.qmimg.cn/s36192/2020/05/29/610a53aa1d08c04e0c.jpg"
		}, {
			"activityId": 35,
			"activityName": "给生活一个拥抱",
			"activityCode": "474611855417462785",
			"cardShelvesCategoryId": 42,
			"imageUrls": "https://img-shop.qmimg.cn/s36192/2020/05/29/a359015f2be252f3b7.jpg"
		}, {
			"activityId": 37,
			"activityName": "拥抱所爱",
			"activityCode": "474612252873490433",
			"cardShelvesCategoryId": 42,
			"imageUrls": "https://img-shop.qmimg.cn/s36192/2020/05/29/b1544272ccbdc1daf4.jpg"
		}, {
			"activityId": 38,
			"activityName": "拥抱同一份热爱",
			"activityCode": "474612560090124288",
			"cardShelvesCategoryId": 42,
			"imageUrls": "https://img-shop.qmimg.cn/s36192/2020/05/29/d5c19896bd99edb39f.jpg"
		}, {
			"activityId": 39,
			"activityName": "拥抱真实的自我",
			"activityCode": "474613118988877825",
			"cardShelvesCategoryId": 42,
			"imageUrls": "https://img-shop.qmimg.cn/s36192/2020/05/29/c7c47682df8d342975.jpg"
		}, {
			"activityId": 36,
			"activityName": "拥抱一样的爱",
			"activityCode": "474612060032389121",
			"cardShelvesCategoryId": 42,
			"imageUrls": "https://img-shop.qmimg.cn/s36192/2020/05/29/a63b3c9f27821c0f81.jpg"
		}],
		"name": "送TA抱抱治愈卡，用心意卡说出爱",
		"activityIds": "40,35,37,38,39,36"
	}, {
		"id": 43,
		"themesList": [{
			"activityId": 33,
			"activityName": "霸气入夏",
			"activityCode": "474611160824172545",
			"cardShelvesCategoryId": 43,
			"imageUrls": "https://img-shop.qmimg.cn/s36192/2020/06/02/93d2e5e3e768c04581.jpg"
		}, {
			"activityId": 34,
			"activityName": "梅“你”不行",
			"activityCode": "474611484393525248",
			"cardShelvesCategoryId": 43,
			"imageUrls": "https://img-shop.qmimg.cn/s36192/2020/06/02/79ba8839a547c49835.jpg"
		}],
		"name": "送TA“梅你不行”卡，美好如期而至",
		"activityIds": "33,34"
	}, {
		"id": 44,
		"themesList": [{
			"activityId": 31,
			"activityName": "夏日宝藏派对",
			"activityCode": "474609071208693761",
			"cardShelvesCategoryId": 44,
			"imageUrls": "https://img-shop.qmimg.cn/s36192/2020/06/02/5f174643c17873cccc.jpg"
		}, {
			"activityId": 32,
			"activityName": "开启肆意狂欢",
			"activityCode": "474610542633451521",
			"cardShelvesCategoryId": 44,
			"imageUrls": "https://img-shop.qmimg.cn/s36192/2020/06/02/fcc00dd039b1853b23.jpg"
		}],
		"name": "送TA夏日宝藏卡，一起肆意狂欢",
		"activityIds": "31,32"
	}, {
		"id": 45,
		"themesList": [{
			"activityId": 43,
			"activityName": "立刻暴富",
			"activityCode": "474615349960560640",
			"cardShelvesCategoryId": 45,
			"imageUrls": "https://img-shop.qmimg.cn/s36192/2020/06/02/c4354f1e3b3b1e5d6d.png"
		}, {
			"activityId": 47,
			"activityName": "事事顺心",
			"activityCode": "474616223470092289",
			"cardShelvesCategoryId": 45,
			"imageUrls": "https://img-shop.qmimg.cn/s36192/2020/06/02/19e4fc54f333831bbe.png"
		}, {
			"activityId": 46,
			"activityName": "梦想成真",
			"activityCode": "474615973796401152",
			"cardShelvesCategoryId": 45,
			"imageUrls": "https://img-shop.qmimg.cn/s36192/2020/06/02/7fa43b1e30f0cfa14d.png"
		}, {
			"activityId": 48,
			"activityName": "身体健康",
			"activityCode": "474616428856770561",
			"cardShelvesCategoryId": 45,
			"imageUrls": "https://img-shop.qmimg.cn/s36192/2020/06/02/13a85c1197ff272c27.png"
		}, {
			"activityId": 44,
			"activityName": "升职加薪",
			"activityCode": "474615521536954369",
			"cardShelvesCategoryId": 45,
			"imageUrls": "https://img-shop.qmimg.cn/s36192/2020/06/02/ea436b65137034f7e9.png"
		}, {
			"activityId": 45,
			"activityName": "顺利脱单",
			"activityCode": "474615674981601280",
			"cardShelvesCategoryId": 45,
			"imageUrls": "https://img-shop.qmimg.cn/s36192/2020/06/02/f211fdd453b4c22917.png"
		}],
		"name": "送TA瑞兽祝福卡，守护美好心意",
		"activityIds": "43,47,46,48,44,45"
	}],
	"banner_activity_name": "拥抱同一份热爱",
	"img": "https://img-shop.qmimg.cn/s36192/2020/06/03/a95139a2af23330d93.jpg",
	"show_type": 1,
	"title": "奈雪の茶心意卡券购买及使用规则"
}
